import { lazy } from '@cobliteam/lazy-with-retries';

import { Location } from '@cobliteam/common-types';

const FleetPolicyPage = lazy(() => import('../pages/FleetPolicyPage'));
const TriggerEventsPage = lazy(() => import('../pages/TriggerEventsPage'));
const TriggersPage = lazy(() => import('../pages/TriggersPage'));
const TriggerSavePage = lazy(() => import('../pages/TriggerSavePage'));
const TriggerEditPage = lazy(() => import('../pages/TriggerEditPage'));
const TriggersLandingPage = lazy(() => import('../pages/TriggersLandingPage'));

const routes = [
  {
    path: Location.FLEET_POLICY,
    component: FleetPolicyPage,
    exact: true,
  },
  {
    path: Location.FLEET_POLICY_TYPE,
    component: TriggerEventsPage,
    exact: true,
  },
  {
    path: Location.TRIGGERS,
    component: TriggersPage,
    exact: true,
  },
  {
    path: Location.TRIGGERS_CREATE,
    component: TriggerSavePage,
    exact: true,
  },
  {
    path: Location.TRIGGERS_EDIT,
    component: TriggerEditPage,
    exact: true,
  },
  {
    path: Location.FLEET_POLICY_LP,
    component: TriggersLandingPage,
    exact: true,
  },
];

export default routes;
